import image1 from "../assets/image1.png";
import image2 from "../assets/image2.png";
import image3 from "../assets/image3.png";
import image4 from "../assets/image4.png";
export const testimonialsData = [
  {
    image: image4,
    review:
      "I have been a client of Fitness Engineers for around 2 years, and I have seen tremendous progress in my fitness journey. The trainers are knowledgeable and supportive, and the workouts are challenging yet achievable. I highly recommend Fitness Engineers to anyone looking for a personalized and effective fitness program.",
    name: "Mayuri Verma",
    status: "Business Consultant",
  },
  {
    image: image2,
    review:
      "Exceptional knowledge and dedication, they have been instrumental in achieving my fitness goals",
    name: "Suny Sharma",
    status: "CA",
  },
  {
    image: image3,
    review:
      "Their personalized approach transformed my perspective on fitness, making every session enjoyable and effective",
    name: "Gaurav Bajaj",
    status: "SOFTWARE ENGINEER",
  },
  {
    image: image1,
    review:
      "I made the right choice by choosing the Fitness Engineers and by choosing the right plan and program I already achieved my ideal body!",
    name: "Ganapathy Subramanian",
    status: "SOFTWARE ENGINEER",
  },
];
